import React from 'react';
import { useInView } from 'react-intersection-observer';
import { Translate } from 'react-localize-redux';
import styled, { css, keyframes } from 'styled-components';

import Heading, { HeadingContainer, SubHeading } from './heading';

import ImgTitle from './images/title_frame.png';

const slideInAnim = keyframes`
  100% {
    transform: translate(0, 0);
  }
`;

export const slideInTime = 0.7;

const Wrapper = styled.div`
overflow-x: hidden;
`;

const Background = styled.section`
  color: #111111;
  position: relative;

  ${({ slideIn, slideInActive }) =>
    slideIn &&
    css`
      ${slideIn === 'left' &&
        css`
          transform: translate(100%, -2.5em);
        `}
      ${slideIn === 'right' &&
        css`
          transform: translate(-100%, -2.5em);
        `}

      ${slideInActive &&
        css`
          animation: ${slideInAnim} ${slideInTime}s cubic-bezier(0, 1, 0, 1)
            both;
        `}
    `}

  ${({ background, topClip }) =>
    background
      ? css`
          padding: 7.5em 0;
          background: ${background};
          ${topClip === 'left'
            ? css`
                clip-path: polygon(
                  0 2.5em,
                  100% 0,
                  100% calc(100% - 2.5em),
                  0 100%
                );
              `
            : css`
                clip-path: polygon(
                  0 0em,
                  100% 2.5em,
                  100% 100%,
                  0 calc(100% - 2.5em)
                );
              `};
        `
      : css`
          padding: 5em 0 0 0;
        `}
`;

const TitleImg = styled.img`
  display: block;
  margin: 0 auto;
`

const Container = styled.div`
  @media (min-width: 768px) {
    margin: 0 auto;
    max-width: 45em;

    ${props =>
      props.vertical &&
      css`
        align-items: center;
        display: flex;
      `}
  }
`;

const Content = styled.div`
  flex: 1;
  padding: 0 1.5em;
`;
const ImageTitle = styled.img`
  width: 50%;
  top: 30px;
  text-align: center;
`;
const Section = ({
  slideIn = 'left',
  background,
  headingInvert   = false,
  headingPosition = 'top',
  imgSrc,
  titleWidth = '50vw',
  children
}) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.25
  });
  return (
    <Wrapper ref={ref}>
      <Background
        background={background}
        slideIn={slideIn}
        slideInActive={inView}
        topClip={headingPosition}
      >
        <Container vertical={headingPosition !== 'top'}>

          {/* タイトル部 */}
          <TitleImg src={imgSrc} style={{width: titleWidth}}/>

          <Content>{children}</Content>
        </Container>
      </Background>
    </Wrapper>
  );
};

export default Section;
